// extracted by mini-css-extract-plugin
module.exports = {"product-card":"close_product-card__9IBfv","close":"close_close__qHNlU"};